export default {
  copyright: `Copyright © ${new Date().getFullYear()} 醍摩豆（成都）信息技术有限公司 版权所有`,
  logout: "登出",
  productName:'HiTeach Mind',
  markDownErr:'Markdown格式错误',
  markDownNote:'请输入正确的Markdown格式',
  defaultMind:{
    templateName:'心智图范本',
    root:'心智图主题',
    node1:'概念1',
    node2:'概念2',
    node3:'概念3',
    node4:'概念4',
  },
  mainMenu: {
    gotoHome: "前往我的管理页",
    rename: "重新命名",
    import: "导入",
    inputMD: "Markdown 文件",
    pasteMD: "Markdown 文字",
    copyMD: "复制文字",
    export: "导出",
    downloadMD: "Markdown (.md)",
    downloadImage: "图片",
    exportStaticMindmap: "发布展示（静态心智图）",
    copyToMyDocuments: "复制到我的文件",
    createCopy: "建立副本",
    alreadyCopied: "已复制到剪贴板",
    coworkMode: "共用",
    backCollect: "返回收集区",
    deleteMindMap: "删除心智图",
  },
  downloadImageSuccess: "图片已成功下载",
  downloadImageFailed: "下载图片失败",
  generateImageFailed: "生成图片失败",
  staticMindmap: {
    title: "心智图主题",
    urlLabel: "私存链接 URL：",
    publicUrlLabel: "公开展示 URL：",
    copied: "URL 已复制到剪贴板",
    loadFailed: "加载静态心智图失败",
    publishDialogTitle: "发布展示",
    modePrivate: "私存链接",
    modePrivateDesc: "仅自己使用，不公开",
    modePublic: "公开展示",
    modePublicDesc: "任何人可搜索浏览",
    publishTitle: "展示标题",
    publishDescription: "心智图简介（选填）",
    publishDescriptionPlaceholder: "请输入文字",
    publishTags: "标签（逗号分隔）",
    publishBtn: "发布",
    publishing: "发布中...",
    publishSuccess: "已公开展示！可至「公开展示管理」查看或删除",
    overwriteHint: "将以目前心智图内容取代 Gallery 中的公开版本",
    overwriteSuccess: "公开展示文件已存在，已直接更新并覆盖现有内容！",
  },
  phoneticFont: {
    loading: "正在加载注音字体...",
    loadFailed: "注音字体加载失败",
  },
  anonymousNameBox: {
    placeholder: "请输入名字(10字以内)",
    welcomeTitle:'欢迎使用HiTeach云端心智图',
    title: "免登快速使用",
    or:'或',
    save: "用此名字",
    loginHint:"登录/申请账号后使用"
  },
  renameBox: {
    title: "重新命名",
    save: "保存变更",
  },
  coworkMode: {
    edit: "协作共编",
    view: "只读模式",
  },
  mindmapTypeSelection: {
    title: "请选择HiTeach心智图类型",
    localMindmap: "创建本地心智图",
    cloudMindmap: "引用云端心智图",
  },
  unsupportFC: "Sharing 网站目前不支持此功能！",
  auth: {
    notLoggedInShareWarning: "您尚未登录，无法进行分享操作。请先登录后再试。"
  },
  initializeFluidRelay: "初始化容器中...请稍后",
  cannotConnect: "无法连接到服务器，请检查网络连接或稍后再试",
  tryingToGetContainer:'读取数据中...请稍候',
  disconnected: "检测到与服务器的连接中断或其他错误，请检查网络，重整页面再试一次",
  initializeOK: "初始化成功",
  initializeFailed: "初始化失败，请检查网址是否正确，如网址正确内容可能已被拥有者删除",
  cannotMoveToChild: "不可移动到自己的子节点",
  saveOK: "保存成功",
  saveFailed: "保存失败",
  alreadyDeleted: "文件目前已被拥有者删除，已无法使用",
  snapshoting: "截图中～",
  updateSnapshot: "更新截图",
  relayout: "整理中～",
  tooManyUsers: "目前在线用户过多，已超过100人，可能会有通信延迟现象，请稍后重试。",
  userLimitReached: "人数已满载",

  新增: "新增节点",
  編輯: "编辑节点",
  輸入文字: "输入文字",
  確定: "确定",
  取消: "取消",
  請先選取節點: "请先选取节点!",
  不可刪除有子項目的節點: "不可刪除有子項目的節點!",
  新增失敗: "新增失败，父节点已被删除!",
  編輯失敗: "编辑失败，所选节点已被删除!",
  加入根節點: "加入根节点",
  左邊: "左边",
  右邊: "右边",
  已是最上面: "已是最上面!",
  已是最下面: "已是最下面!",
  圖片: "图片",
  圖片過大提示字1: "所选图片过大(请小于",
  圖片過大提示字2: "MB)，请重新选择！",
  連結: "连结",
  連結網址: "连结网址",
  連結名稱: "连结名称",
  輸入URL: "输入URL...",
  輸入連結名稱: "输入连结名称...",
  註解: "注解",
  進階設定: "进阶设置",
  線條顏色: "线条颜色",
  節點顏色: "节点颜色",
  preEditHint: "注意：目前的节点之前编辑者是",
  confirmUpdate: "，确定要修改吗?",
  moveNodeTitle: "移动节点",
  moveNodeHint: "请选择父节点",
  noTopic: "无主题",
  menu: {
    新增: "新增",
    刪除: "删除",
    上移: "上移",
    下移: "下移",
    左移:'左移',
    右移:'右移',
    編輯: "编辑",
    複製: "复制",
    檢視圖片: "检视图片",
    最後更新: "最后更新",
    檢視節點變更記錄: "检视节点变更记录",
    lock: "锁定",
    unlock: "解锁",
    locked: "已锁定",
    move: "移动",
    applyColor: "套用色彩",
    applyColorSuccess: "已套用色彩到所有子节点",
    more: "更多",
    allRightLayout: "全向右布局",
    allRightLayoutSuccess: "已将所有第一层子节点调整为右侧布局",
    allLeftLayout: "全向左布局",
    allLeftLayoutSuccess: "已将所有第一层子节点调整为左侧布局",
    noChildrenToApply: "根节点没有子节点可以套用",
    expandAll: "全展开",
    collapseAll: "全收合",
    lockAll: "全锁定",
    unlockAll: "全不锁定",
  },
  treeMenu: {
    currentMoveNode: "要移动的节点 (包含子节点)",
    selectedParentNode: "选取为父节点",
  },
  imgEditor: {
    詢問離開動作: "询问离开动作?",
    保存圖片: "保存图片",
    捨棄變更: "舍弃变更",
    取消: "取消",
  },
  mindCollectPage:{
    viewURL:"检视连结",
    viewEditKey:"检视编辑密码",
    deleteMindMap:"删除心智图",
    editKey:"编辑密码：",
    url:"连结：",
    submitMindMap:"新编心智图缴交任务",
    createRefer:"编辑心智图范本",
    useTemplate:"运用范本",
    seatNum:"座号",
    name:"姓名",
    inputNum:"输入数字",
    inputName:"输入姓名",
    topic:"主题",
    newTopic:"新收集区",
    searchTopic:"搜寻名称...",
    submitClose:"已停止收集！",
    viewClose:"已设置为不允许点击观看内容！",
    templateTips:"Tips: 创建后 可点击「编辑范本」，让使用者以此为参考缴交作业",
    refreshing: "正在刷新中...",
    refreshSuccess: "刷新完成",
  },
  mindmapHome: {
    login: "登录",
    logout: "登出",
    logoutOK: "已登出～",
    share: "共用状态",
    shareShort:'共用',
    delete: "删除",
    rename: "重新命名",
    detailInfo: "详细资料",
    copy: "复制",
    renameFile: "重新命名",
    save: "保存变更",
    haveLinkCanDo: "有链接的人可以",
    closeShare: "停止共用",
    publishShare: "发布共用",
    publishAsAssignmentTemplate: "以此为范本发布作业任务",
    comfirmDelete: "确定要删除此心智图吗？",
    mindmapCreator: "创建者",
    mindmapEditor: "最后更新者",
    createTime: "创建时间",
    updateTime: "更新时间",
    coworkMode: "共用模式",
    myMindMap: "我创建的",
    myMindMapBtn: "我的心智图",
    search: "搜索",
    add:'+ 创建',
    addFile: "私有心智图",
    addCoworkMindMap:'共编心智图',
    addMindCollect:'心智图作业任务',
    addCollectNormal:'文件夹',
    mindmapName: "名称",
    noData: "暂无数据",
    true: "是",
    false: "否",
    setCoworkInHTinfo: "于HT内使用时，强制将Sharing文件公开设置为 协作模式",
    initialize: "初始化中...请稍后",
    initializeFailed: "初始化失败",
    deleting: "删除中...请稍后",
    deletingOKinFront: "删除成功",
    cannotConnect: "无法连接，请检查网络状态",
    saveOk: "保存成功",
    saveFailed: "保存失败",
    confirmDelete:"删除确认",
    mindCollect:{
      share:'设置',
      defaultName:'作业任务名称',
      createTitleSetting:'新增心智图作业任务',
      openSummitTitle:'开放提交任务文件',
      allowViewTitle:'开放观摩文件内容',
      colletSetting:'心智图作业任务设置',
      updateSetting:'心智图作业任务设置',
      confirmDeleteCollectText:'确定要删除心智图作业任务吗? 删除后将无法恢复，文件夹内的文件将一并删除！',
      templateTips:'Tips: 创建后 可点击 「编辑范本」，让使用者以此为参考缴交作业',
    },
    mindCollectNormal:{
      createTitleSetting:'新增一般文件夹',
      createMindMap:'新增心智图',
      defaultName:'文件夹名称',
      colletSetting:'文件夹设置',
      updateSetting:'文件夹设置',
      confirmDeleteCollectText:'确定要删除文件夹吗? 删除后将无法恢复，文件夹内的文件将一并删除！',
    },
    enterShortUrl:'免登入, 请输入心智图或心智图作业任務简码', 
    cannotOpenShortUrl:'简码不存在或已失效～', 
    coworkModeNoteText:{
      task:"任务收集",
      viewLongVer:'只读检视',
      editLongVer:'协作共编',
      view:'检视',
      edit:'共编',
      closeView:'不开放检视',
    },
    moveToFolder:'移入文件夹',
    moveOutFolder:'移出文件夹',
    noFolder:'暂无数据',
    moveSuccess:'移入成功',
    moveFail:'移入失败',
    moveOutSuccess:'移出成功',
    moveOutFail:'移出失败',
    createMindMapTask:'创建心智图作业任务',
    taskSuffix:'作业任务',
    template:'范本',
    refreshClipCode: "重新获取简码",
    clipCodeStillValid: "简码已存在尚未到期，无法更新",
    checkClipCodeError: "检查简码时发生错误",
    clipCodeRefreshSuccess: "简码重新获取成功",
    clipCodeRefreshError: "重新获取简码失败",
    clipCodeAutoUpdated: "简码太久未使用已主动更新，请留意！",
    gallerySubtitle: "大家都在想什么？看看其他人怎么整理知识",
    heroTitle: "今天想整理什么想法？",
    heroSub: "从模板开始，或从一片空白出发，你决定。",
    galleryHeroStats: "数据库累积 {count} 份作品",
    galleryLoginBtn: "开始创作",
    galleryTemplatesTitle: "经典{highlight}参考",
    galleryTemplatesHighlight: "范例",
    galleryTemplatesSub: "点开细看，汲取灵感",
    galleryExploreTitle: "探索公开展示",
    gallerySearchPlaceholder: "搜索心智图名称",
    galleryLoading: "加载中...",
    galleryEmpty: "目前还没有公开的心智图",
    galleryLoadMore: "加载更多",
    galleryTemplateCards: [
      { title: '学习笔记', sub: '课堂笔记整理' },
      { title: 'Brainstorm', sub: '自由发想' },
      { title: '项目规划', sub: 'WBS 拆解' },
      { title: '上课重点', sub: '单元架构' },
      { title: '读书计划', sub: '学习进度追踪' },
    ],
  },
  currentUser: "当前用户",
  privateInfo: "目前文件拥有者设置不提供分享，无法查看",
  refreshHint:'闲置超过10分钟无动作，系统已断开，请重新整理页面',
  beforeDispoeHint:'侦测10分钟没动作，请点击画面，否则即将在1分钟内断开连线',
  inputEditKey:'输入编辑密码',
  sixBit:'6位字元',
  closeMindCollect:'已停止收集',
  notAllowViewHint: "不允许观看提交内容，如为编辑者请输入编辑代码",
  allowEnterEditSuccess:'编辑密码验证成功，允许进入编辑!',
  enterEditKeyWrong:"编辑密码错误，如忘记密码请在收集区重新提交，或向收集区管理者请求密码!",
  writeDownEditKey:'请记下你的编辑权代码，下次开启需输入编辑代码才可编辑:',
  reachMaxOpenFRUsage:'目前分享文档的使用量已达上限，因此无法新增。 ',
  fluidRelayUsage:'分享文档用量：',
  recentClick:'最近点击',
  publicDisplay:'我的公开展示',
  publicDeleteConfirm:'删除后无法恢复，需重新发布，确定删除吗？',
  owner:'所有者：',
  linkShareSuccess:'心智图链接已成功推送',
  linkShareCooldown:'请稍候1分钟再推送心智图链接',
  mindCollectLinkShareSuccess:'心智图作业任务链接已成功推送',
  mindCollectLinkShareCooldown:'请稍候1分钟再推送心智图作业任务链接',
  qrcodeTitle: '扫描 QR Code',
  qrcodeGenerateFailed: '生成 QR Code 失败',
  copyToMine: {
    title: '保存你的心智图',
    btn: '保存成我的心智图',
    loginRequired: '登录后即可',
    benefit1: '保存你的编辑',
    benefit2: '随时继续',
    benefit3: '分享与多人协作',
    goLogin: '前往登录',
    cancel: '取消',
    success: '已保存到我的心智图!',
    failed: '保存失败，请稍后再试',
    copyLabel: '副本',
  },
  playground: {
    title: '游乐场',
    homeBtn: '返回首页',
    mindRoot: '自由创作',
    mindNode1: '好奇探索',
    mindNode1a: '无限可能',
    mindNode2: '智慧学习',
    mindNode2a: '每日一记',
    mindNode3: '悠闲创作',
    mindNode3a: '色彩缤纷',
    mindNode3b: '随手涂鸦',
    mindNode4: '快速行动',
    mindNode4a: '马上开始',
  },
};
